<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Редактирование рубрик "вопрос/ответ" на проектах</h5>
      </div>
      <div class="card-body">
        <div class="flex">
          <div class="form-group">
            <label for="">Проект</label>
            <select @change="loadProjectData" v-model="selectedProject" class="form-control">
              <option value="0" disabled>Выберите проект</option>
              <option v-if="p.is_active" v-for="p in $AllProjects" :value="p.id">{{ p.title }}</option>
            </select>
          </div>
          <div class="form-group flex-grow-1">
            <label for="">Препарат</label>
            <DrugSearchNew
              :onSelect="updateSelectedDrug"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading">
          <div class="alert alert-info" v-if="!records.length">
            <p>Не найдено ни одного вопроса, создайте новый</p>
          </div>
          <div class="text-right mb-2">
            <button @click="addNewRecord" class="btn btn-outline-info" type="button">Добавить новый</button>
          </div>
          <div v-for="(r, i) in records" :key="i" class="faq_block">
            <div class="form-group">
              <label for="">Вопрос</label>
              <textarea rows="2" v-model="r.question" class="form-control"/>
            </div>
            <div>
              <label for="">Ответ</label>
              <HtmlEditor
                :ref="`answerEditor_${i}`"
                :text="r.answer"
              />
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" :id="`ch_${i}`" v-model="r.status">
              <label class="form-check-label" :for="`ch_${i}`">запись активна</label>
            </div>
            <p>Запись будет удалена с проекта в случае отметки "не активна"</p>
          </div>
          <div v-if="records.length" class="text-right">
            <LoadingButton
              title="Сохранить"
              type="button"
              :loading="btnLoading"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => updateRecords()"
              className="btn btn-outline-success"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api';
import DrugSearchNew from "@/components/drugs/DrugSearchNew";
import LoadingButton from "@/components/buttons/LoadingButton";
import HtmlEditor from "@/components/text/HtmlEditor";

export default {
  components: {HtmlEditor, LoadingButton, DrugSearchNew},
  data() {
    return {
      editorApiKey: 'zc3kxtndpmzkkzmiy5z6nvftqwzou0pwryau5q4u02ojy0kl',
      selectedProject: 0,
      selectedDrug: null,
      loading: false,
      btnLoading: false,
      records: [],
    }
  },
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce((acc, p) => {
        acc[p.id] = p;
        return acc;
      }, {})
    },
  },
  methods: {
    async loadProjectData() {
      if (!this.selectedDrug || !this.selectedProject) return;
      this.loading = true;
      this.records = [];
      const {data} = await api.post('/new/drugs/project/faq', {
        drug_id: this.selectedDrug.id,
        project_id: this.selectedProject,
      });
      if (data.success) {
        this.records = data.records.reduce((acc, r) => {
          acc.push({...r, status: true});
          return acc
        }, []);
      }
      this.loading = false;
    },
    addNewRecord() {
      if (!this.selectedDrug || !this.selectedProject) return;
      this.records.push({
        drug_id: this.selectedDrug.id,
        project_id: this.selectedProject,
        question: '',
        answer: '',
        status: true,
      })
    },
    updateSelectedDrug(drug) {
      this.selectedDrug = drug;
      this.loadProjectData();
    },
    async updateRecords() {
      let records = this.records.reduce((acc, r, i) => {
        acc.push({...r, answer: this.$refs[`answerEditor_${i}`][0].localText});
        return acc
      }, [])
      records = records.filter((r) => r.question && r.answer);
      if (!records.length) {
        toastr['warning']('Нет данных для сохранения');
        return;
      }
      this.btnLoading = true;
      const {data} = await api.post('/new/drugs/project/faq', {
        action: 'update',
        drug_id: this.selectedDrug.id,
        project_id: this.selectedProject,
        records
      });
      if (data.success) {
        this.records = data.records.reduce((acc, r) => {
          acc.push({...r, status: true});
          return acc
        }, []);
        toastr['success'](data.message || 'Обновлено');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.btnLoading = false;
    }
  }
}

</script>

<style scoped>
.faq_block {
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid lightgray;
}

</style>
